import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';


@Component({
  selector: 'custom-header',
  templateUrl: 'custom-header.html',
  inputs: ['headerData']
})
export class CustomHeaderPage {

  headerData: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {

  }

}



// WEBPACK FOOTER //
// ./src/components/custom-header/custom-header.ts